import { useCallback } from "react";
import { getCrafts } from "../../../api/Employees";
import { logCustomMessage } from "../../../util/logger";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { useWorkOrderStore } from "../../../store/wo-order";
import { getCraftCodeAccess } from "../../../util/UserHelper";

export default function useGetCraftsForEmployee() {
  const setCrafts = useWorkOrderStore((state) => state.setCarts);

  const getCarts = useCallback(async (employeeId: string) => {
    const response = await getCrafts(employeeId);
    const data = {
      Employee: employeeId,
    };
    logCustomMessage(
      "Get Crafts List without EmployeeId",
      SeverityLevel.Information,
      "Employees/Crafts",
      data,
      response
    );
    return response;
  }, []);

  const getCraftsForEmployee = useCallback(
    async (employeeId: string) => {
      let response = await getCarts(employeeId);
      if (response.status === 200 && !response.isError) {
        if (
          employeeId &&
          response.data.Crafts?.length === 0 &&
          (await getCraftCodeAccess())
        ) {
          //get crafts, regardless of employee
          response = await getCarts("");
        }
        setCrafts(response.data);
      }
      return response;
    },
    [getCarts, setCrafts]
  );

  return { getCraftsForEmployee };
}
